export const datasources = [
  {
    name: "Proxima - SupportApp",
    chains: [
      {
        name: "PebbloRetrievalQA",
        vectorDbs: [
          {
            name: "Vespa",
            version: "8.277.17",
            embeddingModel: "OpenAI - text-embedding-3-small",
            location: "/var/rag/vespa",
            bucket: [
              {
                name: "SharePoint Loader",
                sensitiveData: "PII-SSN, Credit Cards, PII-SSN, Email",
                type: "sharepoint",
              },
              {
                name: "Slack API Loader",
                sensitiveData: "PII-SSN, Credit Cards, PII-SSN, Email",
                type: "slack",
              },
            ],
            packageInfo: {
              projectHomePage: "home",
              documentationUrl: "https://docs.vespa.ai/",
              pypiUrl: "https://pypi.org/project/pyvespa",
              licenceType: "-",
              installedVia: "PIP installation",
              location: "/var/rag/vespa",
            },
          },
        ],
        model: {
          name: "GPT-4o",
          vendor: "OpenAI",
        },
      },
    ],
    summary: {
      family: "Daxa",
      name: "Proxima - SupportApp",
      version: "4.1",
      vectorDB: "Vespa",
      location: "support-kb-index",
      embeddingModel: "OpenAI - text-embedding-3-small",
      models: {
        name: "GPT-4o",
        vendor: "OpenAI",
      },
    },
  },
];
